export const IconBullhorn = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M18.881 8.659 18.8 8.62V3.05c0-.425-.256-.805-.653-.967a1.05 1.05 0 0 0-1.15.226L15.049 4.24a8.7 8.7 0 0 1-6.126 2.516H4.197C3.537 6.757 3 7.289 3 7.945v4.613a2.25 2.25 0 0 0 2.254 2.238h.14l.017 5.942a1.334 1.334 0 0 0 2.664 0h.017v-5.942h.395c2.618 0 5.059.992 6.875 2.794l1.637 1.654c.302.304.754.392 1.149.228.397-.164.653-.544.653-.97v-5.57l.082-.038C19.551 12.58 20 11.728 20 10.776s-.451-1.802-1.119-2.117m-2.195 7.311-.538-.486a10.8 10.8 0 0 0-7.25-2.784h-.813V8.852h.809c2.685 0 5.273-.993 7.258-2.787l.534-.482z" />
    </svg>
  );
};
